package com.macrofocus.eflux.network

import web.cssom.ClassName
import web.dom.DOMTokenList

/**
 * Sets a given class name if the value is true
 */
class TrueBooleanClassname(private val tokens: DOMTokenList<ClassName>?, private val classname: ClassName) {
    var value: Boolean = tokens == null || tokens.contains(classname)
        set(value) {
            if(field != value) {
                if(!value) {
                    tokens?.remove(classname)
                } else {
                    tokens?.add(classname)
                }
                field = value
            }
        }
}